module.exports = __webpack_public_path__ + "img/suivi_vente.96088b0c.png";